import { addDays } from 'date-fns';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { Currency } from '@/generated/gql/graphql.ts';
import { TodayOrFutureDate } from '~/common/zod/date';

export const intakeQuoteLineItemSchema = z.object({
  id: z.string(),
  sequence: z.number(),
  position: z.string(),
  title: z.string().min(1),
  description: z.string().nullable(),
  unitId: z.string().min(1),
  quantity: z.number().positive(),
  pricePerUnit: z.number().min(0),
  commodityGroupId: z.string().min(1),
  earlyDeliveryAt: TodayOrFutureDate.nullable(),
  lateDeliveryAt: TodayOrFutureDate,
});
export type IntakeQuoteLineItem = z.infer<typeof intakeQuoteLineItemSchema>;

export const intakeQuoteLineItemArraySchema = z.array(intakeQuoteLineItemSchema).min(1);

const intakeQuoteLineItemsSchema = z.object({
  lineItems: intakeQuoteLineItemArraySchema,
});
export type IntakeQuoteLineItems = z.infer<typeof intakeQuoteLineItemsSchema>;

export const intakeQuoteHeaderSchema = z.object({
  id: z.string(),
  quoteReference: z.string().trim().min(1),
  currency: z.enum(Currency),
});

export type IntakeQuoteHeaderFormData = z.infer<typeof intakeQuoteHeaderSchema>;

export const intakeQuoteHeaderFormDataDefault: DefaultValues<IntakeQuoteHeaderFormData> = {};

export const intakeQuoteSchema = z.object({ ...intakeQuoteHeaderSchema.shape, ...intakeQuoteLineItemsSchema.shape });

export type IntakeQuoteFormData = z.infer<typeof intakeQuoteSchema>;

export const lineItemDefault: DefaultValues<IntakeQuoteLineItem> = {
  id: '',
  position: '',
  title: '',
  description: '',
  unitId: '',
  quantity: 0,
  pricePerUnit: 0,
  commodityGroupId: '',
  earlyDeliveryAt: null,
  lateDeliveryAt: addDays(new Date(), 17),
};

export const intakeQuoteFormDataDefault: DefaultValues<IntakeQuoteFormData> = {
  lineItems: [],
};
